import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  position: fixed;
`;

export const Main = styled.main`
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing?.medium || "20px"};
  box-sizing: border-box;
`;

export const LoadPage = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  // padding: 1.5rem 2rem;
  padding: 1.5rem;
  color: ${({ theme }) => theme.colors.darkGrey};
  font-weight: 400;

  p {
    padding: 0;
    margin: 0;
  }

  @media screen and (max-width: 1100px) {
    padding: 1.5rem 1.25rem;
  }
`;

export const ControlsPanel = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
`;
